import { initErrorReporting } from "./instrument.ts"; // first: wraps everything below
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App.tsx";
import { initAnalytics } from "./analytics.ts";
import { captureArrival } from "./attribution.ts";
import "./styles.css";

initErrorReporting();
// Called explicitly rather than as a side-effect import: a bare import gets
// tree-shaken when nothing consumes the module's exports, which has silently
// produced zero events on this estate before.
initAnalytics();
// Before the router runs: it replaces the query string, and `?src=` is the only
// attribution three of the four inbound links from gazar.dev carry.
captureArrival();

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
